function formatDateString (date,format='regular',time='') {
  var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  
  var month = d.getUTCMonth()+1;
  var day = d.getUTCDate();
  var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = '0' + month;
  }
  
  var min = '',
      h = '',
      dt = '',
      mt = '',
      tm = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  if(month < 10){
  	mt = 0;
  }
  if(time=='false'){
    tm = '';
  }else{
    // tm = ', '+h+hour+':'+min+minute;
    tm = ', '+newTime[0]+':'+newTime[1];
  }
  
  return (dayname+', '+dt+day+'.'+ mt+month+'.'+ year+tm);
}
var load_first = false;
const load_newsdata = setInterval(function(){
  if(jQuery('.match-details-loaded').length > 0){
    if(load_first == false) {
        var newsURL = "https://fczurich-data.b-cdn.net/api/v1/news?page[number]=1&page[size]=13&sort=-publishDate&filter[isActive]=1&filter[isLightVersion]=true&filter[excludeTag][]=Eisnull";
    
        var settingsData = {
          "url": newsURL,
          "method": "GET",
          "timeout": 0,
          "headers": {
            "Accept": "application/vnd.api+json",
          }
        };
    
        $.ajax(settingsData).done(function (response) {
        
        // Main Loader close     
        /*var gameday_id = getCookie('gameday_id');
        var user_firsttime = getCookie('first_time');
        console.log(gameday_id,user_firsttime);
        if(gameday_id != null && user_firsttime == null){
            
        }
        else {
          $('#status').fadeOut();
          $('#preloader').fadeOut('slow');
        }*/
        
        $('#news_status').fadeOut();
        $('#news_preloader').fadeOut('slow');        
        
        $('.news-filter .multicolumn-list__item').eq(3).css('visibility','visible');
        $('.news-filter .multicolumn-list__item.masonary-grid').eq(1).css('visibility','visible');
        
        
        var totalData = response.data.length;
        var increment = 0;
        
        for(var a=0; a<totalData; a++){
          var json_response = response.data[a].attributes;
          var title = jQuery.trim(json_response.name);
          var description = '';
          
          var url = response.data[a].id;
          if(json_response.urlHandle != null){
            url = json_response.urlHandle;
          }
            
          /*var newscat = '';
          if(json_response.newsCategory !== null ){
    
            for(var nc=0; nc <json_response.newsCategory.translations.length; nc++){
              newscat += ' '+json_response.newsCategory.translations[nc].webName;
            }
          }
    
          var newsTags = json_response.newsTags;
          var totalnewsTags = newsTags.length;
          var tagHTML = '';
          
          if(totalnewsTags > 0){
            for(var nt = 0; nt<totalnewsTags; nt++){
              if(nt > 4){
                break;
              }
              tagHTML += '<div class="button button-small">'+newsTags[nt].translations[0].webName+'</div>';
            }
          } */
          
          // var increment = (ab-1);
    		
          
    
          if(json_response.excerpt != null){
            description = json_response.excerpt;
          }else{
            description = '';
          }
    
          /*if(json_response.description.length > 150){
            description = jQuery.trim(json_response.description).substring(0, 150).split(" ").slice(0, -2).join(" ").replace(/(<([^>]+)>)/ig,"") + "...";
          }
            
          if(increment == 0 && json_response.description.length > 0){
            description = jQuery.trim(json_response.description).substring(0, 350).split(" ").slice(0, -2).join(" ").replace(/(<([^>]+)>)/ig,"") + "...";
          }
    
          if((increment == 1 || increment == 2) && (json_response.description.length > 0)){
            description = jQuery.trim(json_response.description).substring(0, 150).split(" ").slice(0, -2).join(" ").replace(/(<([^>]+)>)/ig,"") + "...";
          }*/
          var imagesrc = '';  
          var imageClass = ''; 
          
          if(a == 0){
              if(json_response.optimizedImage != null){
              imagesrc = json_response.optimizedImage;
              }else if(json_response.image != null){
                imagesrc = json_response.image;
              }else if(json_response.optimizedListImage != null){
                imagesrc = json_response.optimizedListImage;
              }else{
                imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png';
                var imageClass = 'blank-image';
              }
          }
          else {
              if(json_response.optimizedListImage != null){
              imagesrc = json_response.optimizedListImage;
              }else if(json_response.optimizedImage != null){
                imagesrc = json_response.optimizedImage;
              }else if(json_response.image != null){
                imagesrc = json_response.image;
              }else{
                imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/news-blank-image.png';
                var imageClass = 'blank-image';
              }
          }
          
    
          var focusXPercentage = "";
          if(json_response.focusXPercentage != null && json_response.focusXPercentage != ''){
            focusXPercentage = json_response.focusXPercentage+'%';
          }else {
            focusXPercentage = 'center';
          }
    
          var focusYPercentage = "";
          if(json_response.focusYPercentage != null && json_response.focusYPercentage != ''){
            focusYPercentage = json_response.focusYPercentage+'%';
          }else {
            focusYPercentage = 'center';
          }
           
          if(imageClass == 'blank-image'){
            focusXPercentage = 'center';
            focusYPercentage = 'center';
          }
    
          var html = '';
          html += '<div class="multicolumn-card content-container '+a+'">';
            html += '<div class="multicolumn-card__image-wrapper multicolumn-card__image-wrapper--full-width multicolumn-card-spacing">';
              html += '<div class="media media--transparent media--adapt" style="padding-bottom: 16.00338696020322%;">'
                  html += '<img class="multicolumn-card__image lazy" src="'+imagesrc+'" alt="" height="366" width="406" loading="lazy" style="object-position:'+focusXPercentage + ' '+focusYPercentage +'">';
              html += '</div>';
    
              html += '<span class="badge">'+formatDateString(response.data[a].attributes.publishDate,'regular','false')+'</span>';
    
            html += '</div>';
            html += '<div class="multicolumn-card__info"><h3>'+title+'</h3><div class="rte">'+description+'</div></div>';
             html += '<div class="link-wrapper">';
              html += '<a href="/pages/news/'+url+'" class="block-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 64C256 46.33 270.3 32 288 32H415.1C415.1 32 415.1 32 415.1 32C420.3 32 424.5 32.86 428.2 34.43C431.1 35.98 435.5 38.27 438.6 41.3C438.6 41.35 438.6 41.4 438.7 41.44C444.9 47.66 447.1 55.78 448 63.9C448 63.94 448 63.97 448 64V192C448 209.7 433.7 224 416 224C398.3 224 384 209.7 384 192V141.3L214.6 310.6C202.1 323.1 181.9 323.1 169.4 310.6C156.9 298.1 156.9 277.9 169.4 265.4L338.7 96H288C270.3 96 256 81.67 256 64V64zM0 128C0 92.65 28.65 64 64 64H160C177.7 64 192 78.33 192 96C192 113.7 177.7 128 160 128H64V416H352V320C352 302.3 366.3 288 384 288C401.7 288 416 302.3 416 320V416C416 451.3 387.3 480 352 480H64C28.65 480 0 451.3 0 416V128z"></path></svg></a>';
             html += '</div>';
          html += '</div>';
          if(increment == 3){
            if($('.news-filter .multicolumn-list__item').eq(3).hasClass('swisslos-block')){
              increment++;
            }
            // continue
          }
          /*if(increment == 3){
            increment++;
            let link = $('.news-filter .multicolumn-list__item').eq(3).children('div').children('.multicolumn-card__info').children(a).attr('href');
            $('.news-filter .multicolumn-list__item').eq(3).children('div').children('.multicolumn-card__info').after('<div class="link-wrapper"><a target="_blank" href="'+link+'" class="block-btn"><svg xmlns="http://www.w3.org/2000/svg" width="203.631" height="141.945" viewBox="0 0 203.631 141.945"><g id="trial_2" data-name="trial 2" transform="translate(-2369.097 8921.188)"><g id="trial_1" data-name="trial 1"><path id="Union_1" data-name="Union 1" d="M67.3,130.963C50.037,49.947,10.827,13.939,0,3.775,8.5,2.649,96.911,58.2,102.971,61.682,96.224,24.63,80.728,7.537,76.081,0c59.694,30.78,124.655,112.088,124.07,112.088-14.924-4.646-45.063-9.291-45.063-9.291s-47.415-37.483-51.769-40.723c1.162,10.378,2.318,40.433,2.608,40.723,8.194-1.453,48.868-.582,48.868,0,14.923,12.486,35.406,35.717,35.114,35.717C141.042,120.22,67.3,130.963,67.3,130.963Z" transform="translate(2369.097 -8917.757)" fill="#000000"/></g><path id="Union_2" data-name="Union 2" d="M2.5,47.9A2.5,2.5,0,0,1,0,45.4V5.738a2.5,2.5,0,0,1,2.5-2.5H18.042a2.5,2.5,0,1,1,0,5H5V42.9H39.666V30.348a2.5,2.5,0,1,1,5,0V45.4a2.5,2.5,0,0,1-2.5,2.5ZM17.715,30.155a2.5,2.5,0,0,1,.034-3.535L39.787,5H30.023a2.5,2.5,0,0,1,0-5h18.2V16.91a2.5,2.5,0,1,1-5,0V8.628L21.25,30.189a2.5,2.5,0,0,1-3.535-.033Z" transform="translate(2524.5 -8921.188)" fill="#000000"/></g></svg></a></div>');
            //$('.news-filter .multicolumn-list__item').eq(2).addClass('online-shop');
          }*/
          /*if(increment == 6){
            increment++;
            let link = $('.news-filter .multicolumn-list__item').eq(6).children('div').children('.multicolumn-card__info').children(a).attr('href');
            $('.news-filter .multicolumn-list__item').eq(6).children('div').children('.multicolumn-card__info').after('<div class="link-wrapper"><a href="'+link+'" class="block-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 24"><path id="Icon_awesome-shopping-bag" data-name="Icon awesome-shopping-bag" d="M16.5,7.5V6a6,6,0,0,0-12,0V7.5H0V20.25A3.75,3.75,0,0,0,3.75,24h13.5A3.75,3.75,0,0,0,21,20.25V7.5ZM7.5,6a3,3,0,0,1,6,0V7.5h-6ZM15,11.625A1.125,1.125,0,1,1,16.125,10.5,1.125,1.125,0,0,1,15,11.625Zm-9,0A1.125,1.125,0,1,1,7.125,10.5,1.125,1.125,0,0,1,6,11.625Z"></path></svg></a></div>');
            $('.news-filter .multicolumn-list__item').eq(6).addClass('online-shop');
          }*/

          if(increment == 12){
            if($('.multicolumn-list__item').hasClass('ad-available')){
              increment++;
            }
          }
          
          $('.news-filter .multicolumn-list__item').eq(increment).html(html);
          //$('.news-filter .multicolumn-list__item').eq(increment).addClass(newscat + ' news-'+response.data[a].id);
            
          increment++;
        }
        $('.news-filter').addClass('news--loaded');
      });
    
      load_first = true;
      
      
      $('.social-twitter-feed .tagembed-container')
        .html('<div class="tagembed-socialwall" data-wall-id="53389" view-url="https://widget.tagembed.com/53389"></div>')        
        .after('<div class="woman_container tagembed-container hidden" style="width:100%;height:100%;overflow: auto;"><div class="tagembed-socialwall" data-wall-id="117245" view-url="https://widget.tagembed.com/53389"></div></div>');


      setTimeout(load_js, 2000); // Delay 4 seconds in loading function       
    }  
    clearInterval(load_newsdata);
  }
},1000);

$(document).ready(function(){

  // setTimeout(function(){
        
        const add_swosslos_widget = setInterval(function(){
          if(jQuery('.news--loaded').length > 0){
            // $('.news-filter.news--loaded .multicolumn-list__item').eq(4).addClass('swisslos-block');
            $('.news--loaded .swisslos-block .content-container').html('<div id="banner"></div>');
            var first_block_height = $('.news-filter .first-block').height();
            var first_block_width = $('.news-filter .first-block').width();
            $('.news-filter #banner').height(first_block_height);
            new swisslos.SWWidget({
              query: 334,
              target: '#banner'
            });
              
            clearInterval(add_swosslos_widget);
          }
        },1500);
      // },1500);

  var index_array = [];
  let current_index = 1;
  var prev_active = '';
  var next_active = '';
  
   $(document).on('click','.slick-slider.slider-for .news-next',function(){
	  
      var homenz = '',
    	homenzth = '';
      
       
      let current_active = $('.website-home-slider-style-two .slider-for .slick-list .slider-block.slide-active').attr('data-index');
      
      let new_index = parseInt(parseInt(current_index) + parseInt(1));      
      
      /*if(new_index < 7){
        
        if(jQuery.inArray(new_index, index_array) != -1){
          
        }
        else {*/
          
          var settings = {
            "url": "https://fczurich-data.b-cdn.net/api/v1/news?page[number]=1&page[size]=6&filter[isActive]=1&sort=-publishDate&filter[isSpecialArticle]=1&filter[isLightVersion]=true",
            "method": "GET",
            "timeout": 0,
            "headers": {
              "Accept": "application/vnd.api+json"
            },
            "Accept-Encoding": "gzip"
          };
          
          $.ajax(settings).done(function (response) {
            var totalData = response.data.length;
           
            for(var a=0; a<totalData; a++){
              var json_response = response.data[a].attributes;
              
              var url = response.data[a].id;
              if(json_response.urlHandle != null){
                url = json_response.urlHandle;
              }
              
              var imagesrc = "";
              if(json_response.optimizedImage != null){
                imagesrc = json_response.optimizedImage;
              }else if(json_response.image != null){
                imagesrc = json_response.image;
              }else{
                imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/blank-header-image-blue.jpg';
              }
        
              var focusXPercentage = "";
              if(json_response.focusXPercentage != null){
                focusXPercentage = json_response.focusXPercentage+'%';
              }else {
                focusXPercentage = 'center';
              }
        
              var focusYPercentage = "";
              if(json_response.focusYPercentage != null){
                focusYPercentage = json_response.focusYPercentage+'%';
              }else {
                focusYPercentage = 'center';
              }
              
              var object_fit = "cover";
              if(json_response.isFullWidth != 1){
              var object_fit = "contain";
                focusXPercentage = 'center';
                focusYPercentage = 'center';
              }
              
              var title = jQuery.trim(json_response.name);
              homenz += '<div class="slider-block slide-active" data-index="'+ new_index +'">';
                  homenz += '<div class="slider__media" data-isFullWidth="'+json_response.isFullWidth+'">';
                      homenz += '<img data-src="'+imagesrc+'" src="'+imagesrc+'" class="lazy" loading="lazy" alt="" style="object-position: '+focusXPercentage+' '+focusYPercentage+';object-fit:'+object_fit+';">';
                  homenz += '</div>';
                  homenz += '<div class="slideshow__text-wrapper banner__content page-width">';
                    homenz += '<div class="slideshow__text banner__box content-container content-container--full-width-mobile">';
                        homenz += '<h2 class="banner__heading"><a href="/pages/news/'+url+'" class="link--title">'+title+'</a></h2>';
                    homenz += '</div>';
                  homenz += '</div>';
                homenz += '</div>';
                
              
            }

            $('.website-home-slider-style-two .slider-for .slick-list .slider-block').removeClass('slide-active');
            $('.website-home-slider-style-two .slider-for .slick-list').append(homenz);
            
          });
  
          index_array.push(new_index);
          current_index++;
          console.log(new_index);
          $('.website-home-slider-style-two .slider-for .news-prev').show();
          
       /* }
      }
      else {
          
          if(current_active == '6'){
            next_active = parseInt(1);
          }
          else {
            next_active = parseInt(parseInt(current_active) + parseInt(1));
          }
         
          $('.website-home-slider-style-two .slider-for .slick-list .slider-block').removeClass('slide-active');
          $('.website-home-slider-style-two .slider-for .slick-list .slider-block[data-index="'+next_active+'"]').addClass('slide-active');
      }*/
     
   });

  $(document).on('click','.slick-slider.slider-for .news-prev',function(){

    let slide_count = $('.website-home-slider-style-two .slider-for .slick-list .slider-block').length;
    let current_active = $('.website-home-slider-style-two .slider-for .slick-list .slider-block.slide-active').attr('data-index');
    console.log(slide_count);
    if(slide_count == 6){
      if(current_active == '1'){
        prev_active = parseInt(6);
      }
      else {
        prev_active = parseInt(parseInt(current_active) - parseInt(1));
      }
    } else {

      if(current_active == '1'){
        prev_active = parseInt(slide_count);
      }
      else {
        prev_active = parseInt(parseInt(current_active) - parseInt(1));
      }
    }

    $('.website-home-slider-style-two .slider-for .slick-list .slider-block').removeClass('slide-active');
    $('.website-home-slider-style-two .slider-for .slick-list .slider-block[data-index="'+prev_active+'"]').addClass('slide-active');
    
  });
  
  $(document).on('click','.social-filter-btn',function(){
    let filter = $(this).data('filter');
    $(this).addClass('active');
    $(this).siblings('.social-filter-btn').removeClass('active');
    $('.social-twitter-feed .tagembed-container').addClass('hidden');
    $('.social-twitter-feed .'+filter).removeClass('hidden');
  });
});


function load_js()
{
    // Get the head tag
    var head_ID = document.getElementsByTagName("head")[0]; 
    // Create script element       
    var script_element = document.createElement('script');
    // Set the script type to JavaScript
    script_element.type = 'text/javascript';
    // External JS file
    script_element.src = 'https://www.swisslos.ch/media/swisslos/sporttip/sporttip_widgets/v3/bridge.min.js';
    head_ID.appendChild(script_element);

    // Create script element       
    var script_element_2 = document.createElement('script');
    // Set the script type to JavaScript
    script_element_2.type = 'text/javascript';
    // External JS file
    script_element_2.src = 'https://widget.tagembed.com/embed.min.js';
    head_ID.appendChild(script_element_2);
}
